import PlanContentPresetsCompile from "./PlanContentPresetsCompile";
import { useEffect } from "react";
import { usePlanContentPresetsCompileStore } from "../../store/plan-content-presets-compile.store";

function PlanContentPresetsCompileContainer(props) {
	const resetData = usePlanContentPresetsCompileStore((state) => state.reset);

	useEffect(() => {
		return () => {
			resetData();
		};
	}, []);

	return <PlanContentPresetsCompile {...props} />;
}

export default PlanContentPresetsCompileContainer;
